// ** WEB3 Imports
import { useState, useEffect } from "react";
import { useContractRead } from "wagmi";
import { ethers } from "ethers";
const useGetAmountOut = (ContractAddress, ContractABI, Amount, FuncName, args) => {


  const [tokenBlnc, setTokenBlnc] = useState([]);
  const { data, isFetched, refetch,isLoading } = useContractRead({
    address: ContractAddress,
    abi: ContractABI,
    functionName: FuncName,
    args,
    enabled: !!Amount
  });
  useEffect(() => {
    if (data || isFetched) {
      setTokenBlnc(data);
    }
  }, [data]);

  return { tokenBlnc: tokenBlnc, isSuccess: isFetched, refetch,isLoading };
};

export default useGetAmountOut;
